document.addEventListener("DOMContentLoaded", function () {

    document.addEventListener(
        "click",
        function (e) {

            const button = e.target.closest(".sr-headless-checkout");

            if (!button) return;

            // Only validate on Product Page
            const productForm = button.closest("product-form");

            if (!productForm) {
                // This is Cart Drawer / Cart Page checkout
                return;
            }


            if (productForm?.dataset.sizeSelected === "true") {
                return;
            }

            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();

            const error = document.getElementById("size-selection-error");

            if (error) {
                error.style.display = "block";

                error.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }

            return false;

        },
        true
    );

});